import { MenuItem } from "@mui/material";
import type { FC } from "react";

import type { BulkGridSelectionModeEnum } from "@ryde/shared";

import { BulkGridSelectionModeGlyph } from "./bulk-grid-selection-mode-glyph";
import { BulkGridSelectionMenuItemIconStyled } from "./bulk-grid-selection.styled";

interface IBulkGridSelectionModeMenuItemProps {
  mode: BulkGridSelectionModeEnum;
  label: string;
  selected: boolean;
  onSelect: (mode: BulkGridSelectionModeEnum) => void;
  e2eData: string;
}

export const BulkGridSelectionModeMenuItem: FC<
  IBulkGridSelectionModeMenuItemProps
> = ({ mode, label, selected, onSelect, e2eData }) => {
  return (
    <MenuItem
      selected={selected}
      onClick={() => onSelect(mode)}
      data-e2e={e2eData}
    >
      <BulkGridSelectionMenuItemIconStyled>
        <BulkGridSelectionModeGlyph mode={mode} />
      </BulkGridSelectionMenuItemIconStyled>
      {label}
    </MenuItem>
  );
};
